export default "__VITE_ASSET__41b06a6a__"